import Grid from '@mui/material/Grid'

import { SelectString } from '@components/SelectString'
import FilterGridItem from '@components/toolbar/FilterGridItem'

import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

interface Props {
  onChange: (filters: ContractinstellingenSearchFilters) => void
  filters: ContractinstellingenSearchFilters
  options: {
    combis: string[]
  }
}

export const ContractinstellingenFilters = ({
  onChange,
  filters,
  options: { combis },
}: Props) => {
  return (
    <Grid spacing={2} container sx={{ marginBottom: 4 }}>
      <FilterGridItem>
        <SelectString
          label="Combi"
          value={filters.combi}
          options={combis}
          onChange={(value) => onChange({ combi: value })}
          variant="outlined"
        />
      </FilterGridItem>
    </Grid>
  )
}
